export default "__VITE_ASSET__DgN3G8rd__"